module.exports = __webpack_public_path__ + "static/media/sims_dashboardsidenav_background.c6e5a426.png";